import { Assets } from "../styles/assets";
import { LogoContainer, LogoImg } from "./style"

export type LogoProps = {
    margintop?: string;
    marginbottom?: string;
    logoSize?: string;
    center?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ margintop: marginTop, marginbottom: marginBottom, center = false }) => {
    return (
        <LogoContainer $margintop={marginTop} $marginbottom={marginBottom} $center={center}>
            <LogoImg src={Assets.logo} alt="logotipo kinerfy" />            
        </LogoContainer>
    )
}